module.exports = __webpack_public_path__ + "img/ginning.43e6e0a3.svg";